export default {
  username: {
    rule1: 'Please create a username',
    rule2: 'The username is at least 5 characters',
    rule3: 'The username is at most 30 characters',
    rule4: ' The user name must start with a letter and contain only letters, numbers, crosses, and underlines. ',
    rule5: 'Username existed ',
    rule6: 'Username not existed'
  },
  common: {
    rulemaxlen30: 'at most 30 characters'
  },
  email: {
    rule1: 'Please enter email',
    rule2: 'Email incorrect '
  },
  name: {
    rule1: 'Please enter username or email',
    rule2: 'incorrect'
  },
  password: {
    rule1: 'Please enter password ',
    rule2: 'Password is at least 6 characters'
  },
  confirm: {
    rule1: 'Please confirm password',
    rule2: 'Passwords not match!'
  },
  mobile: {
    rule1: 'Please enter phone number',
    rule2: 'Phone number existed',
    rule3: 'Phone number incorrect ',
    rule4: 'Phone number not existed'
  },
  code: {
    rule1: 'Please enter verification code',
    rule2: 'Verification code incorrect'
  },
  agree: {
    rule1: 'Please tick “I agree”'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/public/validator.js